<section class="hero">

    <div class="hero__overlay"></div>

    <div class="hero__container container-redesign">

        <div class="hero__content">

            <p class="hero__eyebrow">
                DETECT MENTAL HEALTH RISKS EARLIER
                WITH AI-DRIVEN MONITORING
            </p>

            <h1 class="hero__title">

                Detect mental
                health risks earlier
                with

                <span>AI-driven monitoring</span>

            </h1>

            <p class="hero__description">

                Real-time monitoring and early detection for safer
                mental healthcare, faster clinical response, and better
                prevention of critical events built for hospitals,
                mental health clinics, and regulated care environments.

            </p>

            <div class="hero__actions">

                <a
    routerLink="/contact-redesign"
    class="hero__button hero__button--primary">

    <span>TALK TO OUR TEAM</span>

    <img
        src="/assets/img/redesign/flecha.svg"
        alt=""
        class="hero__button-icon">

</a>

<a
    href="https://system.demo.myaltheasoft.com"
    class="hero__button hero__button--secondary">

    <span>PLATFORM DEMO</span>

</a>

            </div>

            <p class="hero__note">

                Live platform demo • No commitment

            </p>

        </div>

    </div>

</section>